module.exports = __webpack_public_path__ + "img/person-2.ef369f65.svg";